import { SWAN_VERSION } from '../constants/paths.js';
var SWAN_VERSION_META_NAME = 'swanVersion';

function createSwanVersionMetaTag() {
  if (typeof window !== 'undefined' && !document.querySelector('meta[name="swanVersion"]')) {
    var metaTag = document.createElement('meta');
    metaTag.name = SWAN_VERSION_META_NAME;
    metaTag.content = SWAN_VERSION;
    document.head.appendChild(metaTag);
  }
}

function createSwanGlobalObject(swanBaseUrl) {
  if (typeof window !== 'undefined') {
    window.__swan = {
      version: SWAN_VERSION,
      swanBaseUrl: swanBaseUrl
    };
  }
}

export { SWAN_VERSION_META_NAME, createSwanGlobalObject, createSwanVersionMetaTag };